/* unplugin-vue-components disabled */import { render } from "./WhackAMoleRender.vue?vue&type=template&id=ed2964b0&scoped=true"
import script from "./WhackAMoleRender.vue?vue&type=script&lang=js"
export * from "./WhackAMoleRender.vue?vue&type=script&lang=js"

import "./WhackAMoleRender.vue?vue&type=style&index=0&id=ed2964b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2964b0"]])

export default __exports__